import * as types from '../actionType'

const initialState = []

const sellerInfoOtherServices = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_SERVICE_OF_SELLER:
            return action.payload
        default:
            return state
    }
}


export { sellerInfoOtherServices }